import { handleMessages } from 'poly-eshop4/eshop/ui/js/util';

let downloadTimeout;

function loadDownloads() {
  downloadTimeout = setTimeout(() => {
    let url = $(document).find('[data-account-downloads-content]');
    if (url) {
      url = url.attr('data-account-downloads-content');
      if (!url) {
        clearTimeout(downloadTimeout);
        return;
      }

      $.ajax({
        method: 'GET',
        url,
      }).then(handleMessages).then((resp) => {
        const $content = $(document).find('[data-account-downloads]');
        $content.html(resp);
        loadDownloads();
      });
    }
  }, 15000);
}

$(document).on('click', '[data-account-pricelist-generate]', function (event) {
  event.preventDefault();

  const $this = $(this);
  const $widget = $this.closest('.widget');
  const $content = $widget.find('[data-account-downloads]');

  $widget.addClass('loading');

  $.ajax({
    method: 'GET',
    url: $this.attr('href'),
  }).then(handleMessages).then((resp) => {
    if (resp.html) {
      $content.html(resp.html);
    }
    $widget.removeClass('loading');
    setTimeout(() => {
      loadDownloads();
    }, 15000);
  });
});

$(document).ready(() => {
  loadDownloads();
});
